export enum UserType {
    Admin = 1,
    Doctor = 2, 
    User = 3, 
    ClinicalAdmin = 4, 
    ClinicalSupport = 5, 
    AlignerSuccess = 6
} 